"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusAccountUrlResponseDto = void 0;
class StatusAccountUrlResponseDto {
}
exports.StatusAccountUrlResponseDto = StatusAccountUrlResponseDto;
//# sourceMappingURL=status-account-url-response.dto.js.map